export const ProjectCreationConstants = {
  collectionNameCharacterLimit: 70,
  minimumLength: 0,
};
export const ProjectCreationLabels: any = {
  singleProjectCollection: "Projects Mapped to Collection",
  collectionName: "Collection Name",
};
